import React, { Component } from 'react';
import Slider from "react-slick";
import CalendarIcon from '../../../icons/calendaricon';
import TwitterIcon from '../../../icons/twittericon';
import InstaIcon from '../../../icons/instaicon';
import TextField from '../../TextField';
import DraggerIcon from '../../../icons/draggericon';
import FpgMinusIcon from '../../../icons/fpgminusicon';
import FpgPlusIcon from '../../../icons/fpgplusicon';
import CopyIcon from '../../../icons/copyicon';
import Select from 'react-select';
import UploadForm from './UploadForm';
import DropdownMaster from './../../../component/DropdownMaster';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ErrorPopUp from '../../errorPopUp';
import ErrorScreeningPopUp from '../../errorScreeningPopUp';
//Redux Connect
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../../../redux/bindActionCretor'
import ModalMessage from '../../ModalMessage';

import { EditorState, convertToRaw, ContentState } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

//moment import
import moment from "moment-timezone";

//  Date Picker
import DatePicker from "react-datepicker";

//Loader
import Loader from '../../loader';

//Service import
import service from '../../../services'

//Validation import 
import SimpleReactValidator from 'simple-react-validator';

import PopUpCustomAll from './popUpCustomAll';
import TextEditor from '../../TextEditor';
import commonImage from '../../../commonImage';
import CheckBox from '../../CheckBox';
//sweet alert
import swal from 'sweetalert';
import { isEqual, cloneDeep } from 'lodash';
import RecordPresenceBanner from '../../RecordPresenceBanner';
import ConflictSaveModal from '../../ConflictSaveModal';

let sub;

const mapStateToProps = state => ({
    partnerEventId: state.partnerEventId,
    recordViewers: state.recordViewers,
    recordConflict: state.recordConflict,
    getLoginAdminByID: state.getLoginAdminByID
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};

class PartnerEventsCreate extends Component {
    constructor(props) {
        super(props)

        this._hasLeftPresence = false;

        this.state = {
            editStartVersion: null,
            dispalySchedule: false,
            deleteImageId: '',
            deleteImagePopup: false,
            partnerEventDisabled: false,
            errorPopup: false,
            errorScreeningPopup: false,
            selectedOption: null,
            partnerEventId: this.props.partnerEventId,
            partnerEvent: this.props.partnerEvent,
            messageModal: false,
            previewRecordTalkEvents: [],
            modal: false,
            Hours: '7',
            Mins: '30',
            Stamps: 'AM',
            fileMakerId: "",
            // shift72Id: "",
            ytLink: '',
            title: "",
            description: EditorState.createEmpty(),
            shortDescription: EditorState.createEmpty(),
            longEditorState: EditorState.createEmpty(),
            images: [
                {
                    _id: Math.random(),
                    link: "",
                    inSite: ""
                },
                {
                    _id: Math.random(),
                    link: "",
                    inSite: ""
                },
                {
                    _id: Math.random(),
                    link: "",
                    inSite: ""
                }
            ],
            category: "",
            label: this.props.partnerEventId === "" ? 'Partner Event' : '',
            accessibility: [],
            locationType: [
                { _id: '1', name: 'In-Person' },
                { _id: '2', name: 'Online' },
                // { _id: '3', name: 'Hybrid' }
            ],
            locations: [],
            dateTime: [
                {
                    _id: Math.random(),
                    link: '',
                    date: new Date(),
                    locations: [],
                    locationType: { _id: '2', name: 'Online' },
                    allFestival: false,
                    emptyLocationError: '',
                    endDate: new Date(),
                    waitListSlotValid:'',
                    maxWaitListSlots:0,
                    attendanceInstructions:EditorState.createEmpty(),
                    hideFromLive:false,
                    openCaption: false,
                    accessibility:[],
                    eventiveId:"",
                    start: {
                        date: new Date(),
                        hours: { value: '7', label: '7' },
                        minutes: { value: '30', label: '30' },
                        state: { value: 'AM', label: 'AM' }
                    },
                    end: {
                        date:new Date(),
                        hours: { value: '8', label: '8' },
                        minutes: { value: '30', label: '30' },
                        state: { value: 'AM', label: 'AM' }
                    }
,
                    passBuckets: [],
                }
            ],
            panelists: [{
                _id: Math.random(),
                image: '',
                name: '',
                description: EditorState.createEmpty(),
                instagram: '',
                twitter: ''
            }],
            sponserName: "",
            partnerEventEdited: false,
            isDirty: false,
            showConflictModal: false,
        }

        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            validators: {
                urlValidation: {  // name the rule
                    message: 'Please use a valid name of the :attribute',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/) && params.indexOf(val) === -1
                    },
                    required: false  // optional
                },
                websiteValid: {  // name the rule
                    message: 'Please use a valid name of the :attribute',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/) && params.indexOf(val) === -1
                    },
                    required: false  // optional
                },
                apostrophe: {  // name the rule
                    message: 'Please use a valid name of the :attribute',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^([a-zA-Z '. -]*)$/i) && params.indexOf(val) === -1
                    },
                    required: false  // optional
                },
                companyName: {  // name the rule
                    message: 'Please use a valid name of the :attribute',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^([-a-zA-Z0-9 ' , . & !]*)$/i) && params.indexOf(val) === -1
                    },
                    required: false  // optional
                },
                images: {  // name the rule
                    message: 'At least one image is required',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
            }
        });
        this.apiserve = new service();
    }

    handleChange = selectedOption => {
        this.updateState({ selectedOption });
    };

    normalizeDraftHtml = (editorState) => {
        if (!editorState) return '';
        const content = typeof editorState.getCurrentContent === 'function' ? editorState.getCurrentContent() : null;
        if (!content || !content.hasText()) return '';
        const html = draftToHtml(convertToRaw(content)).trim();
        return html === '<p></p>' || html === '<div></div>' ? '' : html;
    }

    getCurrentFormData = () => {
        const { state } = this;
        return {
            fileMakerId: state.fileMakerId || '',
            ytLink: state.ytLink || '',
            label: state.label || '',
            title: state.title || '',
            sponserName: state.sponserName || '',
            dispalySchedule: !!state.dispalySchedule,
            category: state.category?.value || state.category || '',
            accessibility: (state.accessibility || []).map(a => a.value || a).sort(),
            images: (state.images || []).map(img => ({ 
                link: img.link || '', 
                inSite: img.inSite || '' 
            })),
            dateTime: (state.dateTime || []).map(dt => ({
                 date: dt.date ? moment(dt.date).format('YYYY-MM-DD') : '',
                 endDate: dt.endDate ? moment(dt.endDate).format('YYYY-MM-DD') : '',
                 startHours: dt.start?.hours?.value || '',
                 startMin: dt.start?.minutes?.value || '',
                 startState: dt.start?.state?.value || '',
                 endHours: dt.end?.hours?.value || '',
                 endMin: dt.end?.minutes?.value || '',
                 endState: dt.end?.state?.value || '',
                 locationType: dt.locationType?.value || dt.locationType?._id || '',
                 locations: (Array.isArray(dt.locations) ? dt.locations : (dt.locations ? [dt.locations] : [])).map(l => l.value || l._id || l).sort(),
                 maxWaitListSlots: parseInt(dt.maxWaitListSlots) || 0,
                 hideFromLive: !!dt.hideFromLive,
                 openCaption: !!dt.openCaption,
                 allFestival: !!dt.allFestival,
                 accessibility: (dt.accessibility || []).map(a => a.value || a._id || a).sort(),
                 eventiveId: dt.eventiveId || '',
                 link: dt.link || '',
                 attendanceInstructions: dt.attendanceInstructions ? this.normalizeDraftHtml(dt.attendanceInstructions) : ''
            })),
            panelists: (state.panelists || []).map(p => ({
                name: p.name || '',
                image: p.image || '',
                instagram: p.instagram || '',
                twitter: p.twitter || '',
                description: p.description ? this.normalizeDraftHtml(p.description) : ''
            })),
            shortDescription: this.normalizeDraftHtml(state.shortDescription),
            longDescription: this.normalizeDraftHtml(state.longEditorState),
        };
    }

    markPartnerEventEdited = () => {
        if (!this.initialData) return;
        const currentData = this.getCurrentFormData();
        const isDirty = !isEqual(this.initialData, currentData);
        if (this.state.isDirty !== isDirty) {
            this.setState({ isDirty, partnerEventEdited: isDirty });
        }
    }

    updateState = (newState, callback) => {
        this.setState(newState, () => {
            this.markPartnerEventEdited();
            if (callback) {
                callback();
            }
        });
    }

    _handleBeforeUnload = () => {
        if (this._hasLeftPresence) return;
        this._hasLeftPresence = true;

        const recordId = this.props.partnerEventId;
        if (recordId) {
            this.apiserve.sendevent("RecordPresence|leave", {
                modelName: "partnerEvent",
                recordId: recordId
            });
        }
    }

    componentWillUnmount = () => {
        const recordId = this.props.partnerEventId;

        window.removeEventListener('beforeunload', this._handleBeforeUnload);

        // CRITICAL: Only emit leave in EDIT mode, guard against double-leave
        if (recordId && !this._hasLeftPresence) {
            this.apiserve.sendevent("RecordPresence|leave", {
                modelName: "partnerEvent",
                recordId: recordId
            });
        }

        // this.props.TalkEventEditData('')
        sub.unsubscribe();
        this.props.ClearRecordPresence();
    }

    componentDidMount = () => {
        this.props.ClearRecordPresence();
        if (!this.state.partnerEventId) {
            setTimeout(() => {
                this.initialData = cloneDeep(this.getCurrentFormData());
                this.setState({ isDirty: false, partnerEventEdited: false });
            }, 1000);
        }
        if (this.state.partnerEventId) {
            this.apiserve.sendevent("partnerEvents|getAllDetail", {
                partnerEventId: this.state.partnerEventId
            });
            this.apiserve.sendevent("RecordPresence|join", {
                modelName: "partnerEvent",
                recordId: this.state.partnerEventId
            });
            window.addEventListener('beforeunload', this._handleBeforeUnload);
        }

        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "partnerEvents|create":
                    if (!response.error) {
                        this.setState({
                            loaderFlag: false,
                            partnerEventDisabled: true,
                        })
                        if(response.data.eventiveError && response.data.eventiveError.length > 0){
                            this.setState({
                                errorScreeningPopup: true,
                                errorData : response.data.eventiveError
                            })
                        }
                        else{
                            this.apiserve.success('Created successfully.')
                            this.props.history.push('/filmlist')
                            this.setState({ isDirty: false, partnerEventEdited: false })
                        }
                    }
                    else {
                        this.setState({
                            partnerEventDisabled: false,
                            errorPopup: true,
                            errorMsg: response.data.error ? response.data.error : response.data,
                            loaderFlag: false
                        })
                    }
                    break;
                case "partnerEvents|edit":
                    if (!response.error) {
                        this.setState({
                            loaderFlag: false,
                            partnerEventDisabled: true,
                            partnerEventEdited: false
                        })
                        if(response.data.eventiveError && response.data.eventiveError.length > 0){
                            this.setState({
                                errorScreeningPopup: true,
                                errorData : response.data.eventiveError
                            })
                        }
                        else{
                            this.apiserve.success('Updated successfully.')
                            if (this.state.partnerEventId) {
                                this.apiserve.sendevent("partnerEvents|getAllDetail", {
                                    partnerEventId: this.state.partnerEventId
                                });
                                this.setState({
                                    partnerEventDisabled: false,
                                    isDirty: false,
                                    partnerEventEdited: false
                                })
                            }
                        }
                    } else if (response.data?.error === 'CONFLICT_DETECTED') {
                        this.props.SetRecordConflict({
                            userName: 'another user',
                            updatedAt: response.data?.data?.currentUpdatedAt
                        });
                        this.setState({ showConflictModal: true, loaderFlag: false, partnerEventDisabled: false });
                    } else {
                        this.setState({
                            partnerEventDisabled: false,
                            errorPopup: true,
                            errorMsg: response.data.error ? response.data.error : response.data,
                            loaderFlag: false
                        })
                    }
                    break;
                case "partnerEvents|previewPartnerEvent":
                    if (!response.error) {
                        this.setState({ loaderFlag: false,partnerEventDisabled:false})
                        window.open(process.env.REACT_APP_FRONTEND_ORIGIN_FPG + 'partner-events-preview?id=' + response.data._id);
                    }
                    break;
                case "partnerEvents|getAllDetail":
                    var accessibilityData = response ?.data && response ?.data ?.accessibility ?.map(item => {
                        var accessibility = {
                            value: item._id, label: item.name
                        }
                        return accessibility
                    })


                    var dateTimeDate = response ?.data && response ?.data ?.dateTime ?.map(item => {
                        let hoursStart = moment(item.date).tz("US/Mountain").format('h');
                        let minutesStart = moment(item.date).tz("US/Mountain").format('mm')
                        let stateStart = moment(item.date).tz("US/Mountain").format('A')
                        let yearstart = moment(item.date).tz("US/Mountain").format('YYYY')
                        let monthstart = moment(item.date).tz("US/Mountain").format('MM') - 1
                        let datestart = moment(item.date).tz("US/Mountain").format('DD')

                        let hoursend = moment(item.endDate).tz("US/Mountain").format('h');
                        let minutesend = moment(item.endDate).tz("US/Mountain").format('mm')
                        let stateend = moment(item.endDate).tz("US/Mountain").format('A')
                        let yearend = moment(item.endDate).tz("US/Mountain").format('YYYY')
                        let monthend = moment(item.endDate).tz("US/Mountain").format('MM') - 1
                        let dateend = moment(item.endDate).tz("US/Mountain").format('DD')
                        item.accessibility = item.accessibility.map(acc => { return { value: acc._id, label: acc.name, eventiveId: acc.eventiveId } })
                        var blocksFromHtml = htmlToDraft(item.attendanceInstructions);
                        var { contentBlocks, entityMap } = blocksFromHtml;
                        var contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                        var editorStateShort = EditorState.createWithContent(contentState);
                            
                        var dateTime = {
                            _id: item._id,
                            link: item.link,
                            locationType: item.locationType === undefined ? { _id: '2', label: 'Online' } : { _id: item.locationType, label: item.name },
                            locations: this.getLocations(item.locations),
                            allFestival: item.availableAllFestival,
                            date: new Date(yearstart, monthstart, datestart),
                            endDate: new Date(yearend, monthend, dateend),
                            eventiveId:item.eventiveId,
                            maxWaitListSlots:item.maxWaitListSlots ? item.maxWaitListSlots : 0,
                            attendanceInstructions:editorStateShort || '',
                            hideFromLive:item.hideFromLive ? item.hideFromLive : false,
                            accessibility:item?.accessibility ? item?.accessibility : [],
                            openCaption:item?.accessibility ? item?.accessibility.length > 0 ? true : false : false,
                            waitListSlotValid:'',
                            locationEventiveId:item.locationEventiveId,
                            start: {
                                date: new Date(yearstart, monthstart, datestart),
                                hours: { value: hoursStart, label: hoursStart },
                                minutes: { value: minutesStart, label: minutesStart },
                                state: { value: stateStart, label: stateStart }
                            },
                            end: {
                                date: new Date(yearend, monthend, dateend),
                                hours: { value: hoursend, label: hoursend },
                                minutes: { value: minutesend, label: minutesend },
                                state: { value: stateend, label: stateend }
                            },
                            passBuckets: item ?.passBuckets,
                        }
                        return dateTime
                    })
                    var images = response ?.data && response ?.data ?.images ?.map((image) => {
                        var imageData = {
                            _id: Math.random(),
                            inSite: image.inSite,
                            link: image.link
                        }
                        return imageData
                    })
                    if (response.data.description) {
                        const blocksFromHtml = htmlToDraft(response.data.description);
                        const { contentBlocks, entityMap } = blocksFromHtml;
                        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                        const editorStateShort = EditorState.createWithContent(contentState);
                        this.setState({
                            shortDescription: editorStateShort,
                        })
                    }
                    if (response.data.longDescription) {
                        const blocksFromHtml = htmlToDraft(response.data.longDescription);
                        const { contentBlocks, entityMap } = blocksFromHtml;
                        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                        const editorStateShort = EditorState.createWithContent(contentState);
                        this.setState({
                            longEditorState: editorStateShort,
                        })
                    }
                    var panelists =
                        response ?.data &&
                            response ?.data ?.panelists ?.map((item) => {
                                var panelistsData = {
                                    _id: Math.random(),
                                    image: item.image,
                                    name: item.name,
                                    description: item.description,
                                    instagram: (item.instagram || '').replace('https://www.instagram.com/', ''),
                                    twitter: (item.twitter || '').replace('https://x.com/', '')
                                };
                                return panelistsData;
                            });

                    if (panelists !== undefined) {
                        const docs = panelists.map((e) => {
                            const blocksFromHtml = htmlToDraft(e.description);
                            const { contentBlocks, entityMap } = blocksFromHtml;
                            const contentState = ContentState.createFromBlockArray(
                                contentBlocks,
                                entityMap
                            );
                            e.description = EditorState.createWithContent(contentState);
                            return e;
                        });
                    }
                    this.setState(
                        {
                            panelists:
                                panelists !== undefined
                                    ? panelists
                                    : this.state.panelists,
                        });

                    this.setState({
                        previewRecordTalkEvents: response.data,
                        mediaId: response.data.mediaId,
                        fileMakerId: response.data.fileMakerId,
                        // shift72Id: response.data.shift72Id,
                        ytLink: (response.data.ytLink || '').replace('https://www.', ''),
                        label: response.data.label,
                        title: response.data.title,
                        images: images,
                        sponserName: response.data.sponserName,
                        category: { value: response.data.category && response.data.category._id, label: response.data.category && response.data.category.name },
                        accessibility: accessibilityData,
                        dateTime: dateTimeDate,
                        panelists: panelists,
                        isDirty: false,
                        partnerEventEdited: false
                    }, () => {
                        this.initialData = cloneDeep(this.getCurrentFormData());
                    })
                    if (response?.data?.updatedAt) {
                        this.setState({ editStartVersion: response.data.updatedAt });
                    }
                    this.props.setLastUpdated( {
                        updatedAt: response?.data?.updatedAt,
                        updatedBy: {
                            fname: response?.data?.updatedBy?.fname,
                            lname: response?.data?.updatedBy?.lname
                        }
                    })
                    break;


                case "RecordPresence|join":
                    if (!response.error && response?.data?.recordUpdatedAt) {
                        this.setState({ editStartVersion: response.data.recordUpdatedAt });
                    }
                    break;
                case "RecordPresence|viewersUpdate":
                    if (response?.data?.recordId === this.props.partnerEventId) {
                        const currentUserId = this.props.getLoginAdminByID;
                        const viewers = response?.data?.viewers || [];
                        const currentUserSessionCount = viewers.filter(v => v?.userId === currentUserId).length;
                        const currentUserHasMultipleSessions = currentUserSessionCount > 1;
                        const seenIds = new Set();
                        const filteredViewers = viewers
                            .filter(v => {
                                if (v?.userId === currentUserId) {
                                    return currentUserHasMultipleSessions;
                                }
                                return true;
                            })
                            .filter(v => {
                                if (seenIds.has(v?.userId)) return false;
                                seenIds.add(v?.userId);
                                return true;
                            })
                            .map(v => ({
                                userId: v?.userId,
                                userName: `${v?.fname || ''} ${v?.lname || ''}`.trim() || 'Unknown User'
                            }));
                        this.props.SetRecordViewers(filteredViewers);
                    }
                    break;
                case "RecordPresence|recordUpdated":
                    if (response?.data?.recordId === this.props.partnerEventId && response?.data?.updatedBy?._id !== this.props.getLoginAdminByID) {
                        this.props.SetRecordConflict({
                            userName: `${response?.data?.updatedBy?.fname || ''} ${response?.data?.updatedBy?.lname || ''}`.trim(),
                            updatedAt: response?.data?.updatedAt
                        });
                    }
                    break;
                default:
                    break;
            }
        });
    }

    getLocations = (locations) => {
        return locations && locations.length > 0 && locations.map(item => {
            var location = {
                value: item._id, label: item.name , eventiveId: item.eventiveId
            }
            return location
        })
    }

    onEditorStateChange = (shortDescription) => {
        this.updateState({
            shortDescription
        });
    };

    onEditorStateChangeShort = (editorStateShort) => {
        this.updateState({
            editorStateShort,
        });
    };

    onEditorStateChangeLong = (longEditorState) => {
        this.updateState({
            longEditorState,
        });
    };
    onEditorStateChangeAttendanceInstructions = (attendanceInstructions, id) => {
        this.state.dateTime.map((item) => {
            if(item._id === id){
                item.attendanceInstructions = attendanceInstructions
            }
        })
        this.updateState({});
    };

    onInputChange = (e) => {
        let { name, value } = e.target;
        if (name === 'ytLink') value = value.replace('https://www.', '');
        if (name === 'instagram') value = value.replace('https://www.instagram.com/', '');
        if (name === 'twitter') value = value.replace('https://x.com/', '');
        this.updateState({
            [name]: value
        });
    }

    deleteImagePopup = () => {
        this.state.images.forEach(image => {
            if (image._id === this.state.deleteImageId) {
                image.inSite = ''
            }
        });

        this.state.panelists.forEach(panel => {
            if (panel._id === this.state.deleteImageId) {
                panel.image = ''
            }
        });

        this.updateState({
            deleteImagePopup: false,
            deleteImageId: ''
        })
    }

    deleteImage(id) {
        this.setState({
            deleteImagePopup: true,
            deleteImageId: id
        })
    }

    handleImage(e, id) {
        e.stopPropagation()
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
            this.updateState({
                file: file,
            }, () => {
                const fileList = Math.round((file && file.size / 1024));
                if (fileList > 10240) {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file smaller than 10MB'
                    })
                    return false;
                }
                if (file && (file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
                    setTimeout(() => {
                        this.imageUploadOne(file, id, event.target.result);

                    }, 0)
                } else {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file for PNG,JPG or JPEG'
                    })
                }
            })
        }
    }

    imageUploadOne = (file, id, img) => {
        const imagePreloaderId = `imagePreloader_${id}`
        const newState = { ...this.state }
        newState[imagePreloaderId] = true
        this.updateState(newState)
        var fileSet = commonImage(file,false,'',img)
        fileSet.then((value) => {
                this.state.images.forEach(image => {
                    const imagePreloaderId = `imagePreloader_${id}`
                    const newState = { ...this.state }
                    newState[imagePreloaderId] = false
                    this.updateState(newState)
                    if (image._id === id) {
                        image.inSite = value
                    }

                });
                this.updateState({

                })
            });
    };

    insideOnchange = (e, id) => {
        const { name, value } = e.target
        this.state.images.forEach(inside => {
            if (inside._id === id) {
                inside.link = value
            }
        });
        this.updateState({})
    }

    dropChange = (e) => {
        const { name, value } = e.target;
        this.updateState({
            [name]: { value: value, label: name }
        })
    }

    //Accessibility Master Call
    accessibilityOption = () => {
        var options = []
        this.props.partnerEvent && this.props.partnerEvent.accessibility && this.props.partnerEvent.accessibility.forEach(item => {
            options.push({ value: item._id, label: item.name, eventiveId:item.eventiveId })
        });
        return options
    }

    //Location Master Call
    locationOption = () => {
        var options = []

        this.props.partnerEvent && this.props.partnerEvent.locations && this.props.partnerEvent.locations.forEach(item => {
            if (item._id !== '934e67c906e26dd0737c') {
                options.push({ value: item._id, label: item.name , eventiveId:item.eventiveId, maxWaitListSlots:item?.maxWaitListSlots })
            }
        });
        return options
    }

    handleChangenAccessibility = accessibility => {
        this.setState({
            accessibility: []
        })
        // accessibility && accessibility.forEach(element => {
        this.updateState({
            accessibility: accessibility
        })
        // });     
    };

    handleChangenAccessibilityScreening = (accessibility,id) => {
        let newDateTime = this.state.dateTime
        newDateTime.map((item) => {
            if(item._id === id){
                item.accessibility = accessibility
            }
        })
        this.updateState({
            dateTime:newDateTime  
        })
    };

    //Event Date And Time Push
    addDateAndTime = (item) => {

        var newDateAndTime = {
            _id: Math.random(),
            link: '',
            locationType: { _id: '2', label: 'Online' },
            locations: [],
            allFestival: false,
            date: new Date(),
            endDate: new Date(),
            eventiveId:"",
            waitListSlotValid:'',
            maxWaitListSlots:0,
            attendanceInstructions:EditorState.createEmpty(),
            hideFromLive:false,
            openCaption: false,
            accessibility:[],
            start: {
                date: new Date(),
                hours: { value: '7', label: '7' },
                minutes: { value: '30', label: '30' },
                state: { value: 'AM', label: 'AM' }
            },
            end: {
                date:new Date(),
                hours: { value: '8', label: '8' },
                minutes: { value: '30', label: '30' },
                state: { value: 'AM', label: 'AM' }
            },
            passBuckets: [],
        }
        var oldDateAndTime = this.state.dateTime
        oldDateAndTime.push(newDateAndTime)
        this.updateState({
            dateTime: oldDateAndTime
        });
    }

    //Event Date And Time Remove
    removeDateAndTime = (i) => {
        swal({
            title: "Are you sure?",
            text: "You are about to remove a screening",
            icon: "warning",
            buttons: ['Cancel','Continue'],
            dangerMode: true,
        })
        .then((willDelete) => {
            if (willDelete) {
                var filteredscreening = this.state.dateTime.filter(_ => _._id !== i)
                this.updateState({
                    dateTime: filteredscreening
                });
            }
        });
    }

    handleChangeDate = (date, id,dateType) => {
        this.updateState({})
        this.state.dateTime.forEach(event => {
            if (event._id === id) {
                // event.start.date = date
                // event.date = date
                if(dateType === 'startDate'){
                    event.start.date = date
                    event.date = date
                }else if(dateType === 'endDate'){
                    event.end.date = date
                    event.endDate = date
                }
            }
        });
    }

    handleTimeStartHours = (e, id) => {
        this.updateState({})
        this.state.dateTime.forEach(event => {
            if (event._id === id)
                event.start.hours = e
        });
    }

    onChangeScreeningType = (e, parentId) => {
        const { name, value } = e.target;
        this.state.dateTime.forEach(screeening => {
            if (screeening._id === parentId) {
                screeening[name] = { value: value, label: name }
                screeening['locations'] = []
            }
        });

        this.updateState({})
    };

    handleTimeStartMin = (e, id) => {
        this.updateState({})
        this.state.dateTime.forEach(event => {
            if (event._id === id) {
                event.start.minutes = e
            }
        });
    }

    handleTimeStartStamps = (e, id) => {
        this.updateState({})
        this.state.dateTime.forEach(event => {
            if (event._id === id) {
                event.start.state = e
            }
        });
    }

    handleTimeEndHours = (e, id) => {
        this.updateState({})
        this.state.dateTime.forEach(event => {
            if (event._id === id) {
                event.end.hours = e
            }
        });
    }

    handleTimeEndMin = (e, id) => {
        this.updateState({})
        this.state.dateTime.forEach(event => {
            if (event._id === id) {
                event.end.minutes = e
            }
        });
    }

    handleTimeEndStamps = (e, id) => {
        this.updateState({})
        this.state.dateTime.forEach(event => {
            if (event._id === id) {
                event.end.state = e
            }
        });
    }

    handleChangeLocation = (value, parentId) => {
        console.log(':::handlechangeLoc',value);
        this.state.dateTime.forEach(screeening => {
            if (screeening._id === parentId) {
                if (value !== null || value && value.length !== 0) screeening.emptyLocationError = ''
                else screeening.emptyLocationError = 'The location field is required.'
                screeening.locations = value
                screeening.maxWaitListSlots = value?.maxWaitListSlots ? value?.maxWaitListSlots : 0
            }
        });

        this.updateState({})
    }

    handleLiveCheck = (e,id='') => {
        const { name, checked } = e.target;
        if(name === 'hideFromLive'){
            let newDateTime = this.state.dateTime
            newDateTime.map((item) => {
                if(item._id === id){
                    item.hideFromLive = checked
                }
            })
            this.updateState({
                dateTime:newDateTime  
            })
        } else if(name === 'openCaption'){
            let updateDateTime = this.state.dateTime
            let accessibility = this.props.partnerEvent && this.props.partnerEvent.accessibility.filter(_ => _.identifier === 'opencaption')
            updateDateTime.map((item) => {
                if(item._id === id){
                    item.openCaption = !item.openCaption
                    item.accessibility = item.openCaption ? [accessibility[0]?.eventiveId] : []
                }
            })
            this.updateState({
                dateTime:updateDateTime  
            })
        }
    }

    onChangeLink = (e, parentId) => {
        const { name, value } = e.target;
        this.state.dateTime.forEach(link => {
            if (link._id === parentId) {
                link[name] = value
            }
        });
        this.updateState({})
    };

    //Panalist Push
    addPanalist = (item) => {
        var newPanalist = {
            _id: Math.random(),
            image: '',
            name: '',
            description: EditorState.createEmpty(),
            instagram: '',
            twitter: ''
        }
        var oldPanalist = this.state.panelists
        oldPanalist.push(newPanalist)
        this.updateState({
            panelists: oldPanalist
        });
    }

    //Panalist Remove
    removePanalist = (i) => {
        var filteredPanalist = this.state.panelists.filter(_ => _._id !== i)

        this.updateState({
            panelists: filteredPanalist
        });
    }

    handleImagePanalist(e, id) {
        var self = this;
        e.stopPropagation()
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
            this.setState({
                file: file,
            }, () => {
                const fileList = Math.round((file && file.size / 1024));
                if (fileList >= 5120) {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file smaller than 5MB'
                    })
                    return false;
                }
                if (file && (file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
                    setTimeout(() => {
                        self.imageUploadPanalist(file, id, event.target.result);
                    }, 0)
                } else {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file for PNG,JPG or JPEG'
                    })
                }
            })
        }
    }

    onInputChangePanalist = (e, id) => {
        const { name } = e.target;
        let { value } = e.target;
        if (name === 'instagram') value = value.replace('https://www.instagram.com/', '');
        if (name === 'twitter') value = value.replace('https://x.com/', '');

        this.state.panelists.forEach(pane => {
            if (pane._id === id) {
                pane[name] = value
            }
        });
        this.updateState({});
    }

    imageUploadPanalist = (file, id, img) => {
        const imagePreloaderId = `imagePreloader_${id}`
        const newState = { ...this.state }
        newState[imagePreloaderId] = true
        this.updateState(newState)
        var fileSet = commonImage(file,false,'',img)
        fileSet.then((value) => {
                this.state.panelists.forEach(image => {
                    const imagePreloaderId = `imagePreloader_${id}`
                    newState[imagePreloaderId] = false
                    this.updateState(newState)
                    if (image._id === id) {
                        image.image = value
                    }

                });
                this.updateState({})
            });
    };


    onEditorStateChangeDesc = (description, id) => {
        this.state.panelists.forEach((dataList) => {
            if (dataList._id === id) {
                dataList.description = description;
            }
        });

        this.updateState({});
    };

    onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }
        const { destination, source } = result;
        const oldIndex = source.index;
        const newIndex = destination.index;
        const arr = [...this.state.panelists];
        if (newIndex >= arr.length) {
            var k = newIndex - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
        const updateArr = [];
        arr.forEach(({ _id }, i) => {
            updateArr.push({
                _id: Math.random(),
                image: '',
                name: '',
                description: '',
                instagram: '',
                twitter: ''
            });
        });
        this.updateState({ isDraggable: true });
        const data = { order: updateArr };
        this.updateState({ panelists: arr });
    };

    getMtTime = (date) => {
        //Get offset from mountain time using UTC
        let ABBR = moment.tz("America/Denver").format("z");
        let offDifference = moment().utcOffset() + (ABBR === 'MDT' ? 360 : 420);

        // add that offset in date
        return moment(date).add(offDifference, 'minutes').toISOString()
    }

    checkCustomValidation = () => {
        const { dateTime } = this.state;
        let errorFlag = true;

        dateTime.length > 0 && dateTime.map(date => {
            const type = date.locationType._id || date.locationType.value;
            if (type === "1" || type === "3") {
                try {
                    if (date.locations === null || date.locations === false || date.locations.length === 0 || date.locations.length === 'undefined') {//|| date.locations.length === 0 || date.locations.length === undefined
                        date.emptyLocationError = 'The location field is required.'
                        errorFlag = false;
                    }
                    else {
                        date.emptyLocationError = ''
                        errorFlag = true;
                    }
                } catch (error) {
                    date.emptyLocationError = ''
                }
            }
            else {
                date.emptyLocationError = ''
            }
        })

        this.updateState({})
        return errorFlag;
    }

    submitTalkAndEvents = (e, isPreview) => {
        e.preventDefault();
        let waitlistvalid = false
        this.state.dateTime.map((date) => {
            if(date.waitListSlotValid !== ''){
                waitlistvalid = true
            }
        })
        if (this.validator.allValid() && this.checkCustomValidation() && !waitlistvalid) {

            // Conflict check before save
            if (!isPreview && this.state.partnerEventId && this.props.recordConflict) {
                this.setState({ showConflictModal: true });
                return;
            }

            try {
                this.setState({
                    partnerEventDisabled: true
                })
                var accessibilityData = this.state && this.state.accessibility.map(item => {
                    var accessibility = item.value

                    return accessibility
                })

                var dateTimeDate = this.state && this.state.dateTime.map(item => {
                    console.log(':::item',item);
                    var talkAndEventStartDate = new Date(item && item.start && item.start.date);
                    talkAndEventStartDate.setHours(item.start.state.value === 'PM' || item.start.state.value === 'pm' ? parseInt(item.start.hours.value) === 12 ? parseInt(item.start.hours.value) : parseInt(item.start.hours.value) + 12 : parseInt(item.start.hours.value) === 12 ? parseInt(item.start.hours.value) - 12 : parseInt(item.start.hours.value), item.start.minutes.value);
                    // talkAndEventStartDate.setHours( item.start.state.value === 'PM' || item.start.state.value === 'pm' ? parseInt(item.start.hours.value) + 12: parseInt(item.start.hours.value), item.start.minutes.value);
                    var talkAndEventEndDate = new Date(item && item.end && item.end.date);
                    talkAndEventEndDate.setHours(item.end.state.value === 'PM' || item.end.state.value === 'pm' ? parseInt(item.end.hours.value) === 12 ? parseInt(item.end.hours.value) : parseInt(item.end.hours.value) + 12 : parseInt(item.end.hours.value) === 12 ? parseInt(item.end.hours.value) - 12 : parseInt(item.end.hours.value), item.end.minutes.value);
                    var name = item.attendanceInstructions ? convertToRaw(item.attendanceInstructions.getCurrentContent()) : ''
                    var markup = draftToHtml(name);

                    var dateTime = {
                        _id: item._id.toString(),
                        link: item.link,
                        date: this.getMtTime(talkAndEventStartDate),
                        endDate: this.getMtTime(talkAndEventEndDate),
                        maxWaitListSlots:item.maxWaitListSlots ? item.maxWaitListSlots : 0,
                        attendanceInstructions:markup,
                        hideFromLive:item.hideFromLive ? item.hideFromLive : false,
                        accessibility:item?.accessibility ? item?.accessibility?.map(acc => acc.eventiveId) : [],
                        locationType: item && item.locationType && item.locationType._id || item && item.locationType && item.locationType.value,
                        locations: item.locations.value ? [item.locations.value] : item && item.locations && item.locations.length > 0 ? item.locations.map(e => e.value) : [],
                        availableAllFestival: item.allFestival
                    }
                    
                    let editDateTime = item.eventiveId !== "" ? (item.locationType._id === '1' || item.locationType.value === '1') ? Object.assign(dateTime,{eventiveId:item.eventiveId,locationEventiveId:item.locations.eventiveId || item.locationEventiveId}) : Object.assign(dateTime,{eventiveId:item.eventiveId}) : (item.locationType._id === '1' || item.locationType.value === '1') ? Object.assign(dateTime,{locationEventiveId:item.locations.eventiveId || item.locationEventiveId}) : dateTime ;
                    console.log(':::editDateTime', editDateTime);
                    return editDateTime
                })
                // this.state.panelists.map((item)=>{
                //     item.description=item.description1 ? item.description1 : item.description
                //     delete item.description1
                // })

                var panelists = this.state.panelists.map((element) => {
                    const name =
                        element && element.description
                            ? convertToRaw(element && element.description.getCurrentContent())
                            : "";
                    const markup = draftToHtml(name);

                    var List = {
                        image: element.image,
                        name: element.name,
                        description: markup.trim(),
                        instagram: element.instagram ? 'https://www.instagram.com/' + element.instagram : element.instagram,
                        twitter: element.twitter ? 'https://x.com/' + element.twitter : element.twitter,

                    };

                    return List;
                });

                this.setState({ loaderFlag: true })
                const name = this.state.longEditorState ? convertToRaw(this.state.longEditorState.getCurrentContent()) : ''
                const markup = draftToHtml(name);

                const nameShort = this.state.shortDescription ? convertToRaw(this.state.shortDescription.getCurrentContent()) : ''
                const markupShort = draftToHtml(nameShort);
                if (this.state.partnerEventId) {
                    let editTalkAndEvent = {
                        partnerEventId: this.state.partnerEventId,
                        expectedUpdatedAt: this.state.editStartVersion || undefined,
                        fileMakerId: this.state.fileMakerId,
                        // shift72Id: this.state.shift72Id,
                        ytLink: this.state.ytLink ? 'https://www.' + this.state.ytLink : this.state.ytLink,
                        label: this.state.label,
                        title: this.state.title,
                        // description: markup,
                        description: markupShort,
                        longDescription: markup,
                        images: this.state.images,
                        sponserName: this.state.sponserName,
                        category: this.state.category && this.state.category.value,
                        accessibility: accessibilityData,
                        dateTime: dateTimeDate,
                        panelists: panelists,
                        dispalySchedule: this.state.dispalySchedule,
                    }

                    isPreview ?  this.apiserve.sendevent("partnerEvents|previewPartnerEvent", editTalkAndEvent) : this.apiserve.sendevent("partnerEvents|edit", editTalkAndEvent);
                } else {
                    let createTalkAndEvent = {
                        fileMakerId: this.state.fileMakerId,
                        // shift72Id: this.state.shift72Id,
                        ytLink: this.state.ytLink ? 'https://www.' + this.state.ytLink : this.state.ytLink,
                        label: this.state.label,
                        title: this.state.title,
                        description: markupShort,
                        // description: markup,
                        // shortDescription: markupShort,
                        longDescription: markup,
                        images: this.state.images,
                        sponserName: this.state.sponserName,
                        category: this.state.category && this.state.category.value,
                        accessibility: accessibilityData,
                        dateTime: dateTimeDate,
                        panelists: panelists,
                        dispalySchedule: this.state.dispalySchedule,
                    }
                    // this.state.images.forEach(image => {
                    // delete image._id
                    // });

                    isPreview ?  this.apiserve.sendevent("partnerEvents|previewPartnerEvent", createTalkAndEvent) : this.apiserve.sendevent("partnerEvents|create", createTalkAndEvent);
                }
            } catch (error) {
                this.checkCustomValidation();
                this.setState({
                    messageModal: true,
                    partnerEventDisabled: false,
                })
                this.validator.showMessages();
                this.forceUpdate();
            }
        }
        else {
            this.checkCustomValidation();
            this.setState({
                messageModal: true,
                partnerEventDisabled: false,
            })
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    ClosemessageModal = () => {
        this.setState({
            messageModal: false,
            deleteImagePopup: false
        })
    }

    errorMsgPopup = () => {
        this.setState({
            errorPopup: false
        })
    }

    errorMsgPopupOk = () => {
        this.setState({
            errorScreeningPopup: false
        })
        this.props.history.push('/filmlist')
    }

    cancelTalkAndEventList = () => {
        this.setState({
            discardPopup: true
        })
    }

    previewRecordTalk = (e) => {
        e.preventDefault()
        var accessibilityData = this.state && this.state.accessibility.map(item => {
            var accessibility = item.value

            return accessibility
        })

        var dateTimeDate = this.state && this.state.dateTime.map(item => {
            var talkAndEventStartDate = new Date(item && item.start && item.start.date);
            talkAndEventStartDate.setHours(item.start.state.value === 'PM' || item.start.state.value === 'pm' ? parseInt(item.start.hours.value) === 12 ? parseInt(item.start.hours.value) : parseInt(item.start.hours.value) + 12 : parseInt(item.start.hours.value) === 12 ? parseInt(item.start.hours.value) - 12 : parseInt(item.start.hours.value), item.start.minutes.value);
            // talkAndEventStartDate.setHours( item.start.state.value === 'PM' || item.start.state.value === 'pm' ? parseInt(item.start.hours.value) + 12: parseInt(item.start.hours.value), item.start.minutes.value);
            var talkAndEventEndDate = new Date(item && item.end && item.end.date);
            talkAndEventEndDate.setHours(item.end.state.value === 'PM' || item.end.state.value === 'pm' ? parseInt(item.end.hours.value) === 12 ? parseInt(item.end.hours.value) : parseInt(item.end.hours.value) + 12 : parseInt(item.end.hours.value) === 12 ? parseInt(item.end.hours.value) - 12 : parseInt(item.end.hours.value), item.end.minutes.value);
            var name = item.attendanceInstructions ? convertToRaw(item.attendanceInstructions.getCurrentContent()) : ''
            var markup = draftToHtml(name);

            var dateTime = {
                link: item.link,
                date: this.getMtTime(talkAndEventStartDate),
                endDate:this.getMtTime(talkAndEventEndDate),
                locationType: item && item.locationType && item.locationType._id || item && item.locationType && item.locationType.value,
                maxWaitListSlots:item.maxWaitListSlots ? item.maxWaitListSlots : 0,
                attendanceInstructions:markup,
                hideFromLive:item.hideFromLive ? item.hideFromLive : false,
                accessibility:item?.accessibility ? item?.accessibility : [],
                openCaption:item?.accessibility ? item?.accessibility.length > 0 ? true : false : false,
                // locations:  item.locations ,
                // locations: item && item.locations && item.locations.length > 0 ? item.locations : [],
                locations: item.locations.value ? [{ value: item.locations.value, label: item.locations.label }] : item && item.locations && item.locations.length > 0 ? item.locations.map(e => e.value) : [],
                availableAllFestival: item.allFestival
            }
            let editDateTime = item.eventiveId !== "" ? (item.locationType._id === '1' || item.locationType.value === '1') ? Object.assign(dateTime,{eventiveId:item.eventiveId,locationEventiveId:item.locations.eventiveId || item.locationEventiveId}) : Object.assign(dateTime,{eventiveId:item.eventiveId}) : (item.locationType._id === '1' || item.locationType.value === '1') ? Object.assign(dateTime,{locationEventiveId:item.locations.eventiveId || item.locationEventiveId}) : dateTime ;
            return editDateTime
        })



        var panelists = this.state.panelists.map((element) => {
            const name =
                element && element.description
                    ? convertToRaw(element && element.description.getCurrentContent())
                    : "";
            const markup = draftToHtml(name);

            var List = {
                image: element.image,
                name: element.name,
                description: markup.trim(),
                instagram: element.instagram ? 'https://www.instagram.com/' + element.instagram : element.instagram,
                twitter: element.twitter ? 'https://x.com/' + element.twitter : element.twitter,

            };

            return List;
        });

        var displayNameData = this.props.partnerEvent.category.find(_ => _._id === this.state.category.value || undefined)
        var displayName = displayNameData && displayNameData.displayName ? displayNameData.displayName : ''
        const name = this.state.longEditorState ? convertToRaw(this.state.longEditorState.getCurrentContent()) : ''
        const markup = draftToHtml(name);

        // const nameShort = this.state.editorStateShort ? convertToRaw(this.state.editorStateShort.getCurrentContent()) : ''
        // const markupShort = draftToHtml(nameShort);

        const nameShort = this.state.shortDescription ? convertToRaw(this.state.shortDescription.getCurrentContent()) : ''
        const markupShort = draftToHtml(nameShort);
        let editTalkAndEvent = {}
        // if (this.state.partnerEventId) {
        editTalkAndEvent = {
            partnerEventId: this.state.partnerEventId,
            fileMakerId: this.state.fileMakerId,
            // shift72Id: this.state.shift72Id,
            ytLink: this.state.ytLink ? 'https://www.' + this.state.ytLink : this.state.ytLink,
            label: this.state.label,
            title: this.state.title,
            description: markupShort,
            // description: markup,
            // shortDescription: markupShort,
            longDescription: markup,
            images: this.state.images,
            category: displayName,
            sponserName: this.state.sponserName,
            accessibility: accessibilityData,
            dateTime: dateTimeDate,
            panelists: panelists
        }
        // }
        let previewRecordTalkEvents = this.apiserve.encrypt(editTalkAndEvent)
        window.open(process.env.REACT_APP_FRONTEND_ORIGIN_FPG + 'partner-events-preview?data=' + previewRecordTalkEvents);

    }

    closeAdminUser = () => {
        this.setState({
            discardPopup: false,
            deleteImagePopup: false
        });
    };

    discardPopupYes = () => {
        this.props.CurrentTab(3)
        // this.props.dispatch({type: 'CurrentTab', res: 1})
        this.props.history.push({
            pathname: "/filmlist",
            callFrom: 3
        });
    };

    isShowLink = () => {
        const { dateTime } = this.state;
        var STATE = false;
        dateTime.forEach(date => {
            if (date) {
                if (date.locationType._id === "2" || date.locationType._id === "3" || date.locationType.value === "2" || date.locationType.value === "3")
                    STATE = true;
            } else STATE = false
        });
        return STATE;
    }
    handleChecked = () => {
        this.updateState({ dispalySchedule: !this.state.dispalySchedule })
    }

    validLink = (link) => {
        let regex = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/
        if(regex.test(link)){
            return link
        } else {
            return '/images/image-placeholder.png'
        }
    }

    imageOnError = (event) => {
        event.currentTarget.src = `/images/image-placeholder.png`;
    };

    onInputWaitList = (e, id) => {
        const { name, value } = e.target;
        this.state.dateTime.forEach(screeening => {
            if (screeening._id === id) {
                screeening[name] = value;
                if(name === 'maxWaitListSlots'){
                    if(value.length > 3){
                        screeening['waitListSlotValid'] = 'Value cannot exceed 3 characters.'
                    } else if(/[a-zA-Z!@#$%^&*()_+\[\]{};':"\\|,.<>\/?\-=]+/.test(value)){
                        screeening['waitListSlotValid'] = 'Value can only include numbers.'
                    } else {
                        screeening['waitListSlotValid'] = ''
                    }
                }
            }
        });
        this.updateState({})
    }

    handleKeySlider = (e) => {
        if (e.keyCode === 9) { // Check if the pressed key is Tab (key code 9)
            e.preventDefault(); // Prevent the default tab focus behavior
        }
    }
    render() {
        const { dateTime, panelists } = this.state
        const { partnerEvent } = this.props
        var settings = {
            customPaging: function (i) {
                return (
                    <a>{i + 1}</a>
                );
            },
            dots: true,
            arrows: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
        };
        const hours = [
            { value: '12', label: '12' },
            { value: '1', label: '1' },
            { value: '2', label: '2' },
            { value: '3', label: '3' },
            { value: '4', label: '4' },
            { value: '5', label: '5' },
            { value: '6', label: '6' },
            { value: '7', label: '7' },
            { value: '8', label: '8' },
            { value: '9', label: '9' },
            { value: '10', label: '10' },
            { value: '11', label: '11' },
        ]
        const minutes = [
            { value: '00', label: '00' },
            { value: '05', label: '05' },
            { value: '10', label: '10' },
            { value: '15', label: '15' },
            { value: '20', label: '20' },
            { value: '25', label: '25' },
            { value: '30', label: '30' },
            { value: '35', label: '35' },
            { value: '40', label: '40' },
            { value: '45', label: '45' },
            { value: '50', label: '50' },
            { value: '55', label: '55' },
        ]
        const state = [
            { value: 'AM', label: 'AM' },
            { value: 'PM', label: 'PM' }
        ]
        return (
            <>
            <div className="fpg_tabcontent fpg_create_film fpg_beyond_create_film create_film_beyond">
                {this.state.loaderFlag ?  <Loader /> : ''}
                <RecordPresenceBanner activeViewers={this.props.recordViewers} conflict={this.props.recordConflict} />
                <form>
                    <div className="d_flex">
                        <div className="tab_col create_left_col">
                            <div className="left_col mb_15">
                                <div className="d_flex id_media d_flex_align_center">
                                    {this.state.partnerEventId &&
                                        <span className="id_text d_flex d_flex_align_baseline"><label>Media ID: </label> {this.state.mediaId} </span>
                                    }
                                    {/* <span className="id_text d_flex d_flex_align_baseline"><label>Shift72 ID:</label>
                                            <div className="field_row mb_0">
                                                <TextField type="text" name="shift72Id" id="shift72Id" value={this.state.shift72Id} onChange={this.onInputChange} />
                                            </div>
                                            <span style={{ color: 'red' }}>{this.validator.message('shift72Id', this.state.shift72Id, 'alpha_num')}</span>
                                        </span> */}
                                    <span className="id_text d_flex d_flex_align_baseline"><label>Filemaker ID:</label>
                                        <div className="field_row mb_0">
                                            <TextField type="text" name="fileMakerId" id="fileMakerId" value={this.state.fileMakerId} onChange={this.onInputChange} />
                                        </div>
                                        <span style={{ color: 'red' }}>{this.validator.message('fileMakerId', this.state.fileMakerId, 'alpha_num')}</span>
                                    </span>
                                </div>
                                <Slider {...settings}  >
                                    {this.state.images &&
                                        this.state.images.map((item, index) => {
                                            const imagePreloaderState = `imagePreloader_${item._id}`
                                            return (
                                                <div>
                                                    <div className="media_image mb_0 absolute_loader">
                                                        {this.state[imagePreloaderState] ?
                                                            <Loader />
                                                            :
                                                            <img src={item.inSite ? this.apiserve.imageUrl + item.inSite : item.link ? this.validLink(item.link) : '/images/image-placeholder.png'} alt="image" onError={(e) => this.imageOnError(e)}/>
                                                        }
                                                        <span className="upload_message">Upload PNG/JPEG of max size of 10MB</span>
                                                        <UploadForm item={item} handleImage={(e) => this.handleImage(e, item._id)} deleteImage={() => this.deleteImage(item._id)} iconDelete={true} />
                                                    </div>
                                                    <div className="field_row">
                                                        <div className="field_input relative">
                                                            <input type="text" placeholder="https://cloudfront.aws.com/sdf2345" name='link' id={item._id} value={item.link} onChange={(e) => this.insideOnchange(e, item._id)} onKeyDown={(e) => this.handleKeySlider(e)}
                                                            />
                                                            <span className="copy_box pointer_auto">
                                                                <CopyIcon />
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {index === 0 ?
                                                        <span style={{ color: 'red' }}>{this.validator.message('image or link', item.inSite || item.link, 'required|urlValidation')}</span>
                                                        : ''
                                                    }
                                                </div>
                                            )
                                        })}


                                </Slider>
                            </div>

                            <div className="credit_section artist_section panelsist_section">
                                <div className="credit_header">
                                    <h5>Panelists</h5>
                                </div>
                                <div className="panelsist_content">
                                    <DragDropContext onDragEnd={this.onDragEnd}>
                                        <Droppable droppableId="droppable">
                                            {(provided, snapshot) => (
                                                <ul {...provided.droppableProps} ref={provided.innerRef} >
                                                    {this.state.panelists ?.map((item, index) => {
                                                        const imagePreloaderState = `imagePreloader_${item._id}`
                                                        return (
                                                            <Draggable
                                                                key={item._id}
                                                                draggableId={`'${item._id}'`}
                                                                index={index}
                                                            >
                                                                {(provided, snapshot) => (

                                                                    <div className="inner_artist"
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}
                                                                    >
                                                                        <div className="d_flex upload_beyond_panelists">
                                                                            <span className="drag_icon">
                                                                                <DraggerIcon />
                                                                            </span>
                                                                            <div className="artist_user relative absolute_loader">
                                                                                <div className='artist_img'>
                                                                                {this.state[imagePreloaderState] ?
                                                                                    <Loader />
                                                                                    :
                                                                                    <img src={item.image ? this.apiserve.imageUrl + item.image : '/images/user.png'} alt="image" />
                                                                                }
                                                                                {/* <div className="input_file"> */}
                                                                                <UploadForm item={item} handleImage={(e) => this.handleImagePanalist(e, item._id)} deleteImage={() => this.deleteImage(item._id)} iconDelete={true} />
                                                                                {/* </div> */}
                                                                                </div>
                                                                                <label>Max size 5MB</label>
                                                                            </div>

                                                                            <div className="artist_data">
                                                                                <div className="field_row">
                                                                                    <TextField
                                                                                        type="text"
                                                                                        name='name' id='name'
                                                                                        value={item.name}
                                                                                        onChange={(e) => this.onInputChangePanalist(e, item._id)}
                                                                                    />
                                                                                </div>

                                                                                <div className="field_row">
                                                                                    {/* <textarea 
                                                        type="text"
                                                            name='description' id='description'
                                                            value={item.description}
                                                            onChange={(e)=>this.onInputChangePanalist(e,item._id)}
                                                        /> */}
                                                                                    <TextEditor
                                                                                        name="description"
                                                                                        editorState={item.description}
                                                                                        value={item.description}
                                                                                        onEditorStateChange={(e) =>
                                                                                            this.onEditorStateChangeDesc(
                                                                                                e,
                                                                                                item._id
                                                                                            )}
                                                                                    />
                                                                                </div>

                                                                            </div>
                                                                            <p className="action_wrap">
                                                                                {index === 0 ?
                                                                                    <span className="pointer" onClick={() => this.addPanalist(item)}>
                                                                                        <FpgPlusIcon className="pointer" width="20" height="20" color="#7758B3" stroke="#fff" />
                                                                                    </span>
                                                                                    :
                                                                                    <>
                                                                                    <span className="pointer" onClick={() => this.removePanalist(item._id)}>
                                                                                        <FpgMinusIcon className="pointer" width="20" height="20" color="#7758B3" stroke="#fff" />
                                                                                    </span>
                                                                                    <span className="pointer" onClick={() => this.addPanalist(item)}>
                                                                                        <FpgPlusIcon className="pointer" width="20" height="20" color="#7758B3" stroke="#fff" />
                                                                                    </span>
                                                                                    </>
                                                                                }
                                                                            </p>
                                                                        </div>
                                                                        <div className="field_row horizontal_field">
                                                                            <div className="field_row_inner">
                                                                                <label className="mb_0 text_right"><InstaIcon /></label>
                                                                                <div className="field_input relative">
                                                                                    <span className="sd_input_prefix">https://www.instagram.com/</span>
                                                                                    <input
                                                                                        type="text"
                                                                                        name='instagram' id='instagram'
                                                                                        value={item.instagram}
                                                                                        onChange={(e) => this.onInputChangePanalist(e, item._id)}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="field_row horizontal_field">
                                                                            <div className="field_row_inner">
                                                                                <label className="mb_0 text_right"><TwitterIcon /></label>
                                                                                <div className="field_input relative">
                                                                                    <span className="sd_input_prefix">https://x.com/</span>
                                                                                    <input
                                                                                        type="text"
                                                                                        name='twitter' id='twitter'
                                                                                        value={item.twitter}
                                                                                        onChange={(e) => this.onInputChangePanalist(e, item._id)}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                )}
                                                            </Draggable>
                                                        )
                                                    })}
                                                </ul>
                                            )}
                                        </Droppable>
                                    </DragDropContext>
                                </div>
                            </div>

                        </div>
                        <div className="tab_col create_feature_col">
                            <div className="d_flex w_100">
                                <div className="feature_top">
                                    <div className="feature_title beyond_feature_section">
                                        <div className="field_row">
                                            <TextField
                                                type='text'
                                                name="title" id="title"
                                                value={this.state.title}
                                                onChange={this.onInputChange}
                                                placeholder="This is a talk"
                                            />
                                            <span style={{ color: 'red' }}>{this.validator.message('title', this.state.title, 'required')}</span>
                                        </div>
                                        <div className="d_flex">
                                            <div className="field_row editor_wrapper mr_15">
                                                <div className="field_row_inner">
                                                    <label>Short Description (Catalog)</label>
                                                    <div className="field_input relative">
                                                        <TextEditor name="description" editorState={this.state.shortDescription} value={this.state.description} onEditorStateChange={this.onEditorStateChange} />
                                                        <span style={{ color: 'red' }}>{this.validator.message('description', this.state.description, 'required')}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="field_row editor_wrapper mr_15">
                                                <div className="field_row_inner">
                                                    <label>Long Description (Detail Page)</label>
                                                    <div className="field_input relative">
                                                        <TextEditor name="longDescription" editorState={this.state.longEditorState} value={this.state.longDescription} onEditorStateChange={this.onEditorStateChangeLong} />
                                                        <span style={{ color: 'red' }}>{this.validator.message('description', this.state.description, 'required')}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="wrap_selection_data">
                                        <div className="data_list">
                                            <div className="field_row horizontal_field">
                                                <TextField label="Label"
                                                    name="label" id="label"
                                                    value={this.state.label}
                                                    onChange={this.onInputChange}
                                                    placeholder=''
                                                    fpgerror={''}
                                                />
                                            </div>
                                            <div className="field_row horizontal_field">

                                                <DropdownMaster
                                                    label="Category"
                                                    name="category"
                                                    options={
                                                        partnerEvent && partnerEvent.category
                                                    }
                                                    value={this.state.category.value}
                                                    onChange={this.dropChange}
                                                    fpgerror={this.validator.message('category', this.state.category, 'required')}
                                                />
                                            </div>
                                            <div className="field_row horizontal_field">
                                                <div className="field_row_inner">
                                                    <label>Accessibility</label>
                                                    <div className="select_field relative">
                                                        <Select
                                                            isMulti
                                                            onChange={this.handleChangenAccessibility}
                                                            options={this.accessibilityOption()}
                                                            value={this.state && this.state.accessibility}
                                                        />
                                                        <span className="error">{this.validator.message('accessibility', this.state.accessibility, 'required')}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="wrap_selection_data">
                                <div className="pt_25"></div>
                                <div className="">
                                    <h2 className='mt_15 mb_15'>Screenings</h2>  
                                    {dateTime ?.map((item, i) => {
                                        return (
                                        <div className='field_row screening_info_row'>
                                            <div className="field_row feature_date_time">
                                                <div className="form_group form_group_input textfield_add_remove d_flex d_flex_align_center">
                                                    <div className="form_group_inner d_flex mb_0 horizontal_field d_flex_align_center">
                                                        <label>Event Start Date & Time (MT)</label>
                                                        <div className="form_group_countdown">
                                                            <TextField type="text" name="countDownDate"
                                                                value={moment(item.date).format(
                                                                    "MM/DD/YYYY"
                                                                )}
                                                                placeholder="mm / dd / yyyy"
                                                            />

                                                            <span className="calendar_img">
                                                                {/* <img src={calendar} alt="calendar icon" title="calendar icon"/>   */}
                                                                <DatePicker
                                                                    selected={item.date}
                                                                    onChange={(e) => this.handleChangeDate(e, item._id,'startDate')}
                                                                    minDate={moment().toDate()}
                                                                    placeholder="mm/dd/yyyy"
                                                                    customInput={
                                                                        <span className="calendar">
                                                                            <CalendarIcon />
                                                                        </span>
                                                                    }
                                                                />

                                                            </span>

                                                            <Select
                                                                options={hours}
                                                                value={item.start.hours}
                                                                name='hours'
                                                                placeholder="7"
                                                                onChange={(e) => this.handleTimeStartHours(e, item._id)}
                                                            />
                                                            <Select
                                                                options={minutes}
                                                                value={item.start.minutes}
                                                                name='minutes'
                                                                placeholder="30"
                                                                onChange={(e) => this.handleTimeStartMin(e, item._id)}
                                                            />
                                                            <Select
                                                                options={state}
                                                                value={item.start.state}
                                                                name='state'
                                                                placeholder="AM"
                                                                onChange={(e) => this.handleTimeStartStamps(e, item._id)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <p className="action_wrap d_flex d_flex_align_center action_wrap ">
                                                        {dateTime.length <= 1 ? (
                                                            <span className="pointer" onClick={() => this.addDateAndTime(item, i)}>
                                                                <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                            </span>
                                                        )
                                                            :
                                                            (
                                                                <>
                                                                <span className="pointer" onClick={() => this.removeDateAndTime(item._id)}>
                                                                    <FpgMinusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                </span>
                                                                <span className="pointer" onClick={() => this.addDateAndTime(item, i)}>
                                                                    <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                </span>
                                                                </>
                                                            )
                                                        }
                                                    </p>

                                                </div>

                                                <div className="form_group form_group_input textfield_add_remove d_flex d_flex_align_center">
                                                    <div className="form_group_inner d_flex mb_0 horizontal_field d_flex_align_center">
                                                        <label>Event End Date & Time (MT)</label>
                                                        <div className="form_group_countdown">
                                                            <TextField type="text" name="countDownDate"
                                                                value={moment(item.endDate).format(
                                                                    "MM/DD/YYYY"
                                                                )}
                                                                placeholder="mm / dd / yyyy"
                                                            />

                                                            <span className="calendar_img">
                                                                {/* <img src={calendar} alt="calendar icon" title="calendar icon"/>   */}
                                                                <DatePicker
                                                                    selected={item.endDate}
                                                                    onChange={(e) => this.handleChangeDate(e, item._id,'endDate')}
                                                                    minDate={moment(this.state.dateTime.find((e) => e._id === item._id).start.date).toDate()}
                                                                    placeholder="mm/dd/yyyy"
                                                                    customInput={
                                                                        <span className="calendar">
                                                                            <CalendarIcon />
                                                                        </span>
                                                                    }
                                                                />

                                                            </span>

                                                    <Select
                                                        options={hours}
                                                        value={item.end.hours}
                                                        name='hours'
                                                        placeholder="7"
                                                        onChange={(e) => this.handleTimeEndHours(e, item._id)}
                                                    />
                                                    <Select
                                                        options={minutes}
                                                        value={item.end.minutes}
                                                        name='minutes'
                                                        placeholder="30"
                                                        onChange={(e) => this.handleTimeEndMin(e, item._id)}
                                                    />
                                                    <Select
                                                        options={state}
                                                        value={item.end.state}
                                                        name='state'
                                                        placeholder="AM"
                                                        onChange={(e) => this.handleTimeEndStamps(e, item._id)}
                                                    />    
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="field_row" key={i}>
                                                <div class="form_group_inner d_flex mb_0 horizontal_field d_flex_align_center">
                                                    <label></label>
                                                    <div class="field_row_inner mr_10 mb_10">
                                                        <div class="select_field relative">
                                                            {/* <select name="locationType">
                                                    <option disabled="">Select From Below</option>
                                                    <option value="1">In-Person</option>
                                                    <option value="2">Online</option>
                                                    </select> */}
                                                            <label></label>
                                                            <DropdownMaster
                                                                name="locationType"
                                                                onChange={(e) => this.onChangeScreeningType(e, item._id)}
                                                                value={item && item.locationType && item.locationType._id}
                                                                options={this.state.locationType}
                                                            />
                                                        </div>
                                                    </div>
                                                    {
                                                        item.locationType.value === "2" || item.locationType._id === "2" ?
                                                            <div class="ml_15 mt_15 available_festival">
                                                                <div class="field_row_inner right_check">
                                                                    <div className="checkbox_field_row">
                                                                        <div className="checkBox">
                                                                            <input
                                                                                type="checkbox"
                                                                                id={item._id}
                                                                                name="allFestival"
                                                                                checked={(item.allFestival || (item.locationType.value === "2" || item.locationType._id === "2"))}
                                                                            // value={this.state.allFestival}
                                                                            // onChange={(e) => this.availableAllFestival(e, item._id)} 
                                                                            />
                                                                            <label for={item._id} style={{ width: "120px" }}>Available All Festival?</label>
                                                                        </div>
                                                                    </div>
                                                                    {/* <CheckBox type="checkbox" label="Available All Festival?" value="avfestival" checked={true} id="available" /> */}
                                                                </div>
                                                            </div>
                                                            : ''
                                                    }
                                                    {item.locationType._id === "1" || item.locationType._id === "3" || item.locationType.value === "1" || item.locationType.value === "3" ?
                                                        <>
                                                        <div className="field_row horizontal_field width_265 mb_0">
                                                            <div className="field_row_inner">
                                                                <label style={{ width: "50px", marginRight: "10px" }}>Location</label>
                                                                <div className="select_field relative" style={{ width: "184px" }}>
                                                                    <Select
                                                                        onChange={(e) => this.handleChangeLocation(e, item._id)}
                                                                        options={this.locationOption()}
                                                                        value={item && item.locations}
                                                                    />
                                                                </div>
                                                                {(item.locationType._id === "1" || item.locationType._id === "3" || item.locationType.value === "1" || item.locationType.value === "3") && <span className="error srv-validation-message" style={{ color: 'red' }}>{item.emptyLocationError}</span>}
                                                            </div>
                                                        </div>
                                                        </>
                                                        : ''}
                                                </div>
                                                <div className="field_row horizontal_field">
                                                    <div className="field_row_inner">
                                                        <label>Attendance Instructions</label>
                                                        <div className="field_input relative">
                                                            <TextEditor name="attendanceInstructions" editorState={item.attendanceInstructions} value={item.attendanceInstructions} onEditorStateChange={(e) => this.onEditorStateChangeAttendanceInstructions(e, item._id)} />
                                                        </div>
                                                    </div>
                                                    {/* <Textarea name='attendanceInstructions' onChange={(e) => this.onInputWaitList(e, item._id)} value={item.attendanceInstructions} label="Attendance Instructions" type="text" /> */}
                                                </div>
                                                <div className="field_row horizontal_field d_flex"> 
                                                    <div className="field_row_inner">
                                                        <label>Accessibility</label>
                                                        <div className="select_field relative">
                                                            <Select
                                                                isMulti
                                                                onChange={(e) => this.handleChangenAccessibilityScreening(e, item._id)}
                                                                options={this.accessibilityOption()}
                                                                value={item.accessibility}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="field_row horizontal_field d_flex">                 
                                                    <div className="field_row_inner">
                                                        <label>Hide From Live</label>
                                                        <div className="relative mt_10">
                                                            <div className="checkbox_field_row">
                                                                <div className="checkBox">
                                                                    <input
                                                                        type="checkbox"
                                                                        id={`hideFromLive_`+i}
                                                                        name={`hideFromLive`}
                                                                        checked={item.hideFromLive}
                                                                        onChange={(e) => this.handleLiveCheck(e, item._id)} />
                                                                    <label for={`hideFromLive_`+i} style={{ width: "auto" }}></label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="field_row horizontal_field">
                                                    {<div className="field_row ">
                                                        <div className="form_group_shift d_flex mb_0 horizontal_field d_flex_align_center">
                                                            <span className="id_text d_flex d_flex_align_baseline"><label>Maximum Waitlist Slots :</label>
                                                                <div className="field_row mb_0">
                                                                    <TextField
                                                                        type="text"
                                                                        pattern="[0-9]*"
                                                                        name="maxWaitListSlots"
                                                                        id={item._id}
                                                                        value={item.maxWaitListSlots}
                                                                        onChange={(e) => this.onInputWaitList(e, item._id)}
                                                                    />
                                                                </div>
                                                            </span>
                                                        </div>
                                                        <span className='error srv-validation-message' style={{ color: 'red' }}>{item.waitListSlotValid}</span>
                                                    </div>}
                                                </div>
                                                {<div className="field_row horizontal_field">
                                                    <TextField
                                                        label='Eventive ID'
                                                        type='text'
                                                        name="eventiveId"
                                                        id="eventiveId"
                                                        value={item?.eventiveId}
                                                        disable={true}
                                                    />
                                                </div>}
                                            </div>
                                            {/* <div className="field_row">
                                                <div className="form_group_inner d_flex mb_0 horizontal_field d_flex_align_center">
                                                    <label></label>
                                                <DropdownMaster 
                                                    name="locationType" 
                                                    onChange= {(e) => this.onChangeScreeningType(e,item._id)}
                                                    value={item && item.locationType && item.locationType._id}
                                                    options={this.state.locationType}
                                                />
                                                    {
                                                            item.locationType._id === "1" || item.locationType._id === "3" || item.locationType.value === "1" || item.locationType.value === "3" ?
                                                            <>
                                                            <div className="field_row horizontal_field">
                                                                <div className="d_flex mb_0 d_flex_align_center">
                                                                    <label></label>
                                                                    <div className="field_row horizontal_field width_265">
                                                                        <div className="field_row_inner">
                                                                            <label>Location</label>
                                                                            <div className="select_field relative"> 
                                                                                <Select
                                                                                    isMulti
                                                                                    onChange= {(e) => this.handleChangeLocation(e,item._id)}
                                                                                    options={this.locationOption()}
                                                                                    value={item && item.locations}
                                                                                />
                                                                            </div>
                                                                            { (item.locationType._id === "1" || item.locationType._id === "3" || item.locationType.value === "1" || item.locationType.value === "3") && <span className="error srv-validation-message" style={{ color: 'red' }}>{item.emptyLocationError}</span> }
                                                                        </div>
                                                                    </div>
                                                                </div>                                                
                                                            </div>
                                                            </>
                                                            
                                                            : ''
                                                        }
                                                </div>    
                                            </div>  */}
                                        </div>
                                        )
                                    }
                                    )}
                                </div>
                                {
                                                    // this.isShowLink() ?
                                    <div className="field_row horizontal_field">
                                        <TextField label="YT Event Link"
                                            name="ytLink" id="ytLink"
                                            value={this.state.ytLink}
                                            onChange={this.onInputChange}
                                            placeholder=''
                                            prefix={true}
                                            prefixWidth="https://www."
                                        />
                                    </div>
                                    // : ''
                                }
                                <div className="field_row horizontal_field">
                                    <DropdownMaster
                                        label="Sponsor Name"
                                        name="sponserName"
                                        options={(this.props.eventSponsors || []).map(s => ({ _id: s.name, name: s.name }))}
                                        value={this.state.sponserName}
                                        onChange={(e) => this.updateState({ sponserName: e.target.value })}
                                    />
                                </div>
                                <div className="mt_10">
                                    <CheckBox
                                        label="Display in Schedule"
                                        type="checkbox"
                                        id='dispalySchedule'
                                        name="dispalySchedule"
                                        checked={this.state.dispalySchedule}
                                        onChange={this.handleChecked}
                                    />
                                </div>
                            </div>

                        </div>
                        <div className="text_center field_row w_100 buttons_outer mb_0">
                            <button className="uppercase" type='button' onClick={(e) => this.cancelTalkAndEventList(e)} >CANCEL</button>
                            {/* {this.state.partnerEventId && */}
                            <button className="uppercase prev_btn" type='button' onClick={(e) => this.submitTalkAndEvents(e,true)}>PREviEW</button>
                            {/* } */}
                            <button className={`uppercase ${(!this.state.partnerEventId || this.state.isDirty) ? 'active' : ''}`} type='button' onClick={(e) => this.submitTalkAndEvents(e, false)}  disabled={this.state.partnerEventDisabled || (this.state.partnerEventId && !this.state.isDirty)}>SAVE</button>
                        </div>
                    </div>
                </form>
                {this.state.messageModal &&
                    <ModalMessage messageModal={this.state.messageModal} withoutEmail="Few or all of the required fields are missing. Please scroll up and check to add and confirm and resubmit" ClosemessageModal={this.ClosemessageModal} />
                }
                {this.state.errorPopup ?
                    <ErrorPopUp
                        errorMsg={this.state.errorMsg}
                        errorMsgPopup={this.errorMsgPopup}
                    />
                    : ''
                }
                {this.state.errorScreeningPopup ?
                    <ErrorScreeningPopUp 
                        errorMsg={this.state.errorData}
                        errorMsgPopup={this.errorMsgPopupOk}
                    />
                    : ''
                }
                {this.state.discardPopup ? (
                    <PopUpCustomAll
                        HeaderName="Discard Changes?"
                        insideDetails="Leaving this page without saving will discard all changes"
                        insideData="Do you want to proceed?"
                        popupState={this.closeAdminUser}
                        yesPopUp={this.discardPopupYes}
                    />
                ) : (
                        ""
                    )}
                {this.state.deleteImagePopup ? (
                    <PopUpCustomAll
                        HeaderName="Delete Image?"
                        insideDetails="Are You Sure ?"
                        insideData="You want to delete this image"
                        popupState={this.closeAdminUser}
                        yesPopUp={this.deleteImagePopup}
                    />
                ) : (
                        ""
                    )}
            </div>

            <ConflictSaveModal
                isVisible={this.state.showConflictModal}
                conflict={this.props.recordConflict}
                onClose={() => this.setState({ showConflictModal: false })}
            />
            </>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(PartnerEventsCreate)